import React from 'react';
import { Link } from 'react-router-dom'
import { MDBListGroup, MDBListGroupItem } from "mdbreact";
import { Consumer } from '../../../../contextProvider/ContextProvider'

const ListGroupPage = props => {
    return (
        <Consumer>
            {
                (context) => {
                    let color = context.state.themeStatus ? '#33b5e5' : '#d83434'
                    return (
                        <MDBListGroup className="mt-1" style={{ width: "100%" }}>
                            {
                                props.data.map((val, index) => {
                                    return <Link key={index} to={`/main/${val}`}> <MDBListGroupItem style={{ background: color }} className=" mt-1 d-flex justify-content-between align-items-center text-white"><strong>{val}</strong>
                                    </MDBListGroupItem></Link>
                                })
                            }
                        </MDBListGroup>
                    )
                }
            }

        </Consumer>

    );
};

export default ListGroupPage;